<template>
  <div class="page">
    <div class="header-box">
      <div class="title">汉高胶粘剂技术（广东）有限公司</div>

      <div class="menu-box" v-if="currUser && currUser.roleCode === '0'">
        <router-link tag="div" to="/appointment/apply">
          <div class="iconfont icon-calendar-check"></div>
          我要预约
        </router-link>
        <router-link class="last" tag="div" to="/appointment/list">
          <div class="iconfont icon-reloadtime"></div>
          我的记录
        </router-link>
      </div>

      <div class="menu-box" v-if="currUser && currUser.roleCode == '10'">
        <router-link tag="div" to="/appointment/confirm_list">
          <div class="iconfont icon-calendar-check"></div>
          访客审核
        </router-link>

        <!-- <router-link class="last" tag="div" @click="getLink">
          <div class="iconfont icon-reloadtime"></div>
          邀请登记
        </router-link> -->
      </div>

      <div class="menu-box" v-if="currUser && currUser.roleCode == '20'">
        <router-link tag="div" to="/appointment/confirm_list">
          <div class="iconfont icon-calendar-check"></div>
          访客审核
        </router-link>
        <div class="last" @click="getLink">
          <div class="iconfont icon-renyuanguanli2"></div>
          邀请绑定
        </div>
      </div>

    </div>
    <div class="tip-box" v-if="currUser && currUser.roleCode === '0'">
      <div class="title">预约步骤</div>
      <div class="content">
        <p>1、点击[我要预约]</p>
        <p>2、录入个人的来访信息</p>
        <p>3、提交预约</p>
        <p>4、进行实人认证，认证采集照片可用于刷脸过闸</p>
        <p>5、待审核通过后,凭预约信息可进入相应园区</p>
        <p>6、可在[我的记录]里查看审批状态</p>
        <div>注意事项:</div>
        <p>1、进入区禁止携带香烟、火机</p>
        <p>2、进入园区/库区请不要随意拍照</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      info: null
    }
  },
  components: {},
  computed: {
    ...mapState({
      currUser: (state) => state.currUser
    })
  },
  created() {
    // this.onLoad()
  },
  activated() {
    // this.onLoad()
  },
  methods: {
    copy(message) {
      var input = document.createElement("input");
      input.value = message;
      document.body.appendChild(input);
      input.setAttribute("readonly", "readonly");
      input.select();
      input.setSelectionRange(0, input.value.length), document.execCommand('Copy');
      this.$toast('链接已复制')
    },
    getLink(e) {
      this.axios
        .get('employee/getLink', { params: { roleCode: e.key } })
        .then(res => {
          let successUrl = `${window.location.origin}/employee/bind?t=${res.data}`
          console.log(successUrl)
          this.copy(successUrl)
        });

    },
    onLoad() {
      this.axios
        .get('account')
        .then((res) => {
          if (res.errcode === 0) {
            const dd = Object.assign({}, this.currUser, res.result)
            this.info = dd
            this.$store.dispatch('setUserInfo', dd)
          } else {
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    goBuy() {
      this.$router.push({ path: '/buy' })
    }
  }
}
</script>

<style scoped lang="less">
.page {
  background: #fff;
  min-height: 100vh;
}

.header-box {
  background: #3a88f2;
  height: 250px;
  position: relative;

  .title {
    color: #fff;
    font-size: 22px;
    text-align: center;
    line-height: 120px;
  }

  .menu-box {
    position: absolute;
    bottom: -20px;
    left: 3%;
    border: solid 1px #cfcfcf;
    border-radius: 5px;
    background: #FFF;
    display: flex;
    width: 94%;
    text-align: center;
    height: 130px;
    padding: 20px 0;
    box-sizing: border-box;

    >div {
      flex: 1;
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      font-size: 14px;
    }

    .iconfont {
      font-size: 45px;
      margin-bottom: 10px;
      color: #528ae8;
    }

    .last {
      border-left: solid 1px #ccc;

      .iconfont {
        color: #56beec;
      }
    }
  }
}

.tip-box {
  margin: 50px 0 20px 0;

  .title {
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    position: relative;

    &::before {
      display: block;
      background: #3a88f2;
      width: 5px;
      height: 18px;
      content: '';
      margin-left: 5px;
      margin-right: 5px;
    }

    font-size: 16px;
    font-weight: bold;
  }

  .content {
    font-size: 14px;
    padding: 5px 10px;

    div {
      padding: 5px 0;
      font-weight: bold;
    }

    p {
      margin: 0;
      line-height: 30px;
    }
  }
}
</style>
